import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import { 
    ResultData, ResultDataNew, ResultType
} from "../../enums/index.js";
import ResultFormatterBase from "../ResultFormatterBase.js";

class GenericResultFormatter extends ResultsFormatterBase{
    constructor(pitchFormatters, hitFormatters, newStructure) {
        super();

        if (!(pitchFormatters instanceof Array)){
            throw new TypeError('pitchFormatters must be an array of formatters');
        }

        if (!(pitchFormatters.every( x => x instanceof ResultFormatterBase))){
            throw new TypeError('pitchFormatters must be an array of ResultFormatterBase instances');
        }

        if (!(hitFormatters instanceof Array)){
            throw new TypeError('hitFormatters must be an array of formatters');
        }

        if (!(hitFormatters.every( x => x instanceof ResultFormatterBase))){
            throw new TypeError('hitFormatters must be an array of ResultFormatterBase instances');
        }

        if (typeof(newStructure) !== 'undefined' && typeof(newStructure) !== 'boolean') {
            throw new TypeError('newStructure must be undefined or bool');
        }

        this.pitchFormatters = pitchFormatters;
        this.hitFormatters = hitFormatters;
        this.newStructure = !!newStructure;
    }

    format(results) {
        if (!this.pitchFormatters.length && !this.hitFormatters.length) {
            return results;
        }

        const dataProp = this.newStructure ? ResultDataNew.Data.key: ResultData.Data.key;
        const typeProp = this.newStructure ? ResultDataNew.Type.key: ResultData.Type.key;

        for (let i = 0; i < results.length; i++){
            let result = results[i];

            if (!result || !result.hasOwnProperty(dataProp) || !result[dataProp]){
                continue;
            }

            if (ResultType.hasPitch(result[typeProp])) {
                result = this.formatPitch(result);
            }
            if (ResultType.hasHit(result[typeProp])) {
                result = this.formatHit(result);
            }

            // in theory we will work on references here, but at some stage a deep copy may be required
            results[i] = result;
        }

        return results;
    }

    formatPitch(result){
        this.pitchFormatters.forEach(formatter => result = formatter.format(result));
        return result;
    }

    formatHit(result){
        this.hitFormatters.forEach(formatter => result = formatter.format(result));
        return result;
    }
};

export default GenericResultFormatter;